import {
  KanbanComponent,
  ColumnsDirective,
  ColumnDirective,
  DialogEventArgs,
  CardClickEventArgs,
} from "@syncfusion/ej2-react-kanban";
import { useEffect, useRef, useState } from "react";
import {
  getBankHolidays,
  getProjectFolder,
  getJobs,
  getOperations,
  getSimilarJobs,
  getStartedJobByUser,
} from "../../services/ApiService";
import { ToastUtility } from "@syncfusion/ej2-react-notifications";
import { useAuth } from "../../utility/useAuth";
import { IJob } from "../../types/IJob";
import { getWorkingDays, shortDateFormat } from "../../utility/dateHelpers";
import {
  DropDownButtonComponent,
  MenuEventArgs,
} from "@syncfusion/ej2-react-splitbuttons";
import { useNavigate } from "react-router";
import { IJobAction, JobAction } from "../JobAction/JobAction";
import {
  HeaderLabelText,
  LabelText,
  TextInDot,
  TitleLabelText,
} from "./JobKanbanView.styles";
import { Col, Container, Row } from "react-grid-system";
import { Query } from "@syncfusion/ej2-data";
import { useStoreActions, useStoreState } from "../../store";
import { User } from "oidc-client";
import signalRService from "../../services/signalRService";
import { IJobActionMessage } from "../../types/IJobActionMessage";
import { JobActionType } from "../../types/JobActionType";
import {
  addOrUpdateJob,
  getJobProgress,
  getMinutesRemaining,
  IsJobDue,
} from "../../utility/jobHelper";
import { IOperation } from "../../types/IOperation";
import { JobStatus } from "../../types/JobStatus";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";

export const JobKanbanView: React.FC = () => {
  const navigate = useNavigate();

  const refJobAction = useRef<IJobAction>(null);

  const { jobs, searchValue, warehouse, operationFilter, showOnlyOnHoldJobs } = useStoreState(
    (state) => state.appSettings,
  );
  const { setJobs, setStartedJob, setSimilarJobs } = useStoreActions(
    (actions) => actions.appSettings,
  );

  let kanbanObj: KanbanComponent | null;
  const auth = useAuth();

  function DialogOpen(args: DialogEventArgs): void {
    args.cancel = true;
  }

  function CardDoubleClick(args: CardClickEventArgs): void {
    navigate(`/job/${args.data.jobNumber}`);
  }

  const items = [
    {
      id: "viewJobDetails",
      text: "View Job Details",
    },
    {
      id: "viewProjectFolder",
      text: "View Project Folder",
    },
    {
      id: "viewBom",
      text: "Bill Of Materials",
    },
    {
      id: "addImages",
      text: "Add Images",
    },
    {
      id: "showSimilarImages",
      text: "Show Similar Images",
    },
    {
      id: "addDocuments",
      text: "Add Documents",
    },
    {
      separator: true,
    },
    {
      id: "startOperation",
      text: "Start Operation",
      iconCss: "ddb-icons e-edit",
    },
    {
      id: "stopOperation",
      text: "Stop Operation",
    },
    {
      id: "completeOperation",
      text: "Complete Operation",
    },
    {
      id: "reworkOperation",
      text: "Rework Operation",
    },
    {
      id: "holdProductionOrder",
      text: "Hold Production Order",
    },
    {
      id: "addNotes",
      text: "Add Notes",
    },
    {
      id: "printLabel",
      text: "Print CS Packing Label",
    },
    {
      separator: true,
    },
    {
      id: "completeProductionOrder",
      text: "Production Order Complete",
    },
  ];

  const rejectedOpertationitems = [
    {
      id: "viewJobDetails",
      text: "View Job Details",
    },
    {
      id: "viewProjectFolder",
      text: "View Project Folder",
    },
    {
      id: "viewBom",
      text: "Bill Of Materials",
    },
    {
      id: "addImages",
      text: "Add Images",
    },
    {
      id: "showSimilarImages",
      text: "Show Similar Images",
    },
    {
      id: "addDocuments",
      text: "Add Documents",
    },
    {
      separator: true,
    },
    {
      id: "reworkOperation",
      text: "Rework Operation",
    },
    {
      id: "addNotes",
      text: "Add Notes",
    },
    {
      id: "printLabel",
      text: "Print CS Packing Label",
    },
  ];

  const completedOperationItems = [
    {
      id: "viewJobDetails",
      text: "View Job Details",
    },
    {
      id: "viewProjectFolder",
      text: "View Project Folder",
    },
    {
      id: "viewBom",
      text: "Bill Of Materials",
    },
    {
      id: "addImages",
      text: "Add Images",
    },
    {
      id: "showSimilarImages",
      text: "Show Similar Images",
    },
    {
      id: "addDocuments",
      text: "Add Documents",
    },
    {
      separator: true,
    },
    {
      id: "addNotes",
      text: "Add Notes",
    },
    {
      id: "printLabel",
      text: "Print CS Packing Label",
    },
  ];

  const onHoldItems = [
    {
      id: "viewJobDetails",
      text: "View Job Details",
    },
    {
      id: "viewProjectFolder",
      text: "View Project Folder",
    },
    {
      id: "viewBom",
      text: "Bill Of Materials",
    },
    {
      id: "addImages",
      text: "Add Images",
    },
    {
      id: "showSimilarImages",
      text: "Show Similar Images",
    },
    {
      id: "addDocuments",
      text: "Add Documents",
    },
    {
      separator: true,
    },
    {
      id: "unholdProductionOrder",
      text: "UnHold Production Order",
    },
    {
      id: "addNotes",
      text: "Add Notes",
    },
    {
      id: "printLabel",
      text: "Print CS Packing Label",
    },
  ];

  function onSelect(id: string | undefined, job: IJob) {
    if (id === "viewJobDetails") {
      navigate(`/job/${job.jobNumber}`);
    } else if (id === "viewProjectFolder") {
      getProjectFolder(auth, job.jobNumber)
        .then((folderPath) => {
          if (folderPath && folderPath.length > 0) {
            window.open(folderPath, "_blank");
          } else {
            const message = `No Project Folder  found for ${job.jobNumber} job`;
            ToastUtility.show(message, "Info", 2000);
          }
        })
        .catch((error) => {
          const message = `Failed to get Project Folder path. Error: ${error}`;
          ToastUtility.show(message, "Error", 2000);
        });
    } else if (id === "viewBom") {
      navigate(`/bom/${job.jobNumber}`);
    } else if (id === "addImages") {
      navigate(`/job-images/${job.jobNumber}`);
    } else if (id === "addDocuments") {
      navigate(`/job-documents/${job.jobNumber}`);
    } else if (id === "showSimilarImages") {
      getSimilarJobs(auth, job.jobNumber)
        .then((jobs) => {
          if (jobs && jobs.length > 0) {
            setSimilarJobs(jobs);
            navigate(`/similar-jobs-images`);
          } else {
            const message = `No similar jobs found`;
            ToastUtility.show(message, "Info", 2000);
          }
        })
        .catch((error) => {
          const message = `Failed to get similar jobs. Error: ${error}`;
          ToastUtility.show(message, "Error", 2000);
        });
    } else if (id === "startOperation") {
      refJobAction.current?.startJob(job, false);
    } else if (id === "stopOperation") {
      refJobAction.current?.stopJob(job);
    } else if (id === "reworkOperation") {
      refJobAction.current?.reworkJob(job);
    } else if (id === "completeOperation") {
      refJobAction.current?.completeJob(job);
    } else if (id === "completeProductionOrder") {
      refJobAction.current?.completeProductionOrder(job);
    } else if (id === "addNotes") {
      refJobAction.current?.addJobNote(job);
    } else if (id === "printLabel") {
      refJobAction.current?.printLabel(job);
    } else if (id === "holdProductionOrder") {
      refJobAction.current?.holdProductionOrder(job);
    } else if (id === "unholdProductionOrder") {
      refJobAction.current?.unholdProductionOrder(job);
    }
  }

  function getColour(job: IJob) {
    if (job.jobStatus === JobStatus[JobStatus.Closed]) {
      return "#d3d3d3";
    }

    if (job.jobStatus === JobStatus[JobStatus.InUse]) {
      return "#ffa310";
    }

    if (job.jobStatus === JobStatus[JobStatus.Error]) {
      return "#f0c7c5";
    } else {
      return "#bedfc2";
    }
  }

  function getProgressColour(progress: number) {
    if (progress >= 100) {
      return "DarkRed";
    } else if (progress >= 75) {
      return "#ffa310";
    }
    return "Blue";
  }

  const columnTemplate = (props: { [key: string]: string }) => {
    const minutes = jobs
      .filter((j) => j.operation === props.headerText)
      .map((j) => j.minutesPlanned - j.minutesLogged);
    return (
      <div className="header-template-wrap" style={{ height: 100 }}>
        <Container fluid>
          <Row align="stretch">
            {/* <div className="header-text">{props.headerText}</div> */}
            <TooltipComponent content={props.headerText}>
              <HeaderLabelText>{props.headerText}</HeaderLabelText>
            </TooltipComponent>
          </Row>
          <Row align="stretch">
            <LabelText>Items: {props.count}</LabelText>
          </Row>
          <Row align="stretch">
            <LabelText>
              Minutes:{" "}
              {minutes
                .filter((m) => m > 0)
                .reduce((sum, current) => sum + current, 0)}{" "}
              remaining
            </LabelText>
          </Row>
          <Row align="stretch">
            <LabelText>
              Minutes:{" "}
              {Math.abs(
                minutes
                  .filter((m) => m < 0)
                  .reduce((sum, current) => sum + current, 0),
              )}{" "}
              overrun
            </LabelText>
          </Row>
        </Container>
      </div>
    );
  };

  function cardTemplate(props: IJob) {
    const jobColour = getColour(props);
    let jobComplexity = Number(props.jobComplexity);
    if (isNaN(jobComplexity)) {
      jobComplexity = 0;
    }
    let width = getJobProgress(props);
    if (width > 100) {
      width = 100;
    }
    return (
      <div
        className="card-template"
        style={{ backgroundColor: jobColour }}
        key={props.jobNumber}
      >
        <Container fluid style={{ marginLeft: 5 }}>
          <Row align="stretch">
            <Col sm={4}>
              <TitleLabelText style={{ marginLeft: "-20px", textAlign: "left" }}>
                {props.jobNumber}
              </TitleLabelText>
            </Col>
            <Col sm={2}>
              {props.onHold ? (
                <img alt="" height="14" width="14" src="images/red-flag.png" />
              ) : (
                <></>
              )}
            </Col>
             <Col sm={2}>
              <TextInDot>
                <div style={{ marginTop: "-5px" }}>{jobComplexity}</div>
              </TextInDot>
            </Col>
            <Col sm={4}>
              <DropDownButtonComponent
                id={props.jobNumber}
                iconCss="e-icons e-menu"
                cssClass="e-caret-hide"
                style={{ backgroundColor: jobColour }}
                items={
                  props?.operation === "QUAR"
                    ? rejectedOpertationitems
                    : props?.operation === "COMPLETED"
                      ? completedOperationItems
                      : props?.onHold === true
                        ? onHoldItems
                        : items
                }
                select={(i: MenuEventArgs) => onSelect(i.item.id, props)}
              ></DropDownButtonComponent>
            </Col>
          </Row>
          <Row align="stretch">
            <LabelText>{props.customerName}</LabelText>
          </Row>
          <Row align="stretch">
            <LabelText>{props.stockCode}</LabelText>
          </Row>
          <Row align="stretch">
            <LabelText>{props.description}</LabelText>
          </Row>
          <Row align="stretch">
            <Col sm={7}>
              <hr
                style={{
                  background: getProgressColour(getJobProgress(props)),
                  color: "lime",
                  borderColor: getProgressColour(getJobProgress(props)),
                  height: "2px",
                  width: `${(width * 150) / 100}%`,
                  marginLeft: "-15px",
                  marginRight: "-20px",
                }}
              />
            </Col>
            <Col sm={2}>
              <LabelText style={{ marginRight: "-40px"}} >{getJobProgress(props)}%</LabelText>{" "}
            </Col>
          </Row>
          <Row align="stretch">
            <LabelText>
              {getMinutesRemaining(props)} minutes remaining
            </LabelText>
          </Row>
          <Row align="stretch">
            <Col sm={6}>
              <div
                style={{
                  color: IsJobDue(props) ? "DarkRed" : "black",
                  marginLeft: "-17px",
                }}
              >
                {shortDateFormat(props.scheduledEndDate)}
              </div>
            </Col>
            <Col sm={2}>
              (
              {getWorkingDays(
                new Date(),
                new Date(props.scheduledEndDate),
                bankHolidays,
              )}
              )
            </Col>
          </Row>
          
          {props.openLoggedJobs.map((job) => (
            <Row align="stretch">
              <div id="spinner">
                <img
                  alt=""
                  height="24"
                  width="24"
                  src="images/man_person_icon.png"
                />
              </div>
              <LabelText>
                {" "}
                {job.associate} {job.operation}
              </LabelText>
            </Row>
          ))}
        </Container>
      </div>
    );
  }

  function loadJobs(warehouse?: string) {
    getJobs(auth, warehouse)
      .then((data) => {
        setJobs(data);
      })
      .catch((error) => {
        const message = `Failed to get jobs. Error: ${error}`;
        console.error(`Failed to get jobs. Error: ${error}`);
        ToastUtility.show(message, "Error", 2000);
      });
  }

  const [userToken, setUser] = useState<User | null>(null);
  const [operations, setOperations] = useState<IOperation[]>([]);
  const [bankHolidays, setBankHolidays] = useState<Date[]>([]);

  useEffect(() => {
    auth.getUser().then((user) => {
      setUser(user);
    });
  }, []);

  useEffect(() => {
    if (userToken) {
      signalRService.startConnection(userToken);

      signalRService.onReceiveMessage((receivedMessage) => {
        const jobActionMessage: IJobActionMessage = JSON.parse(receivedMessage);

        console.log(`Message received: ${JSON.stringify(jobActionMessage)}`);

        if (jobActionMessage) {
          if (!jobs || jobs.length === 0) {
            return;
          }

          if (
            jobActionMessage.jobAction === JobActionType.JobsReloaded.toString()
          ) {
            loadJobs(warehouse);
            kanbanObj?.refresh();
          } else if (
            jobActionMessage.jobAction ===
            JobActionType.CompleteProductionOrder.toString()
          ) {
            const newjobs = [
              ...(jobs?.filter(
                (job) => job.jobNumber !== jobActionMessage.jobNumber,
              ) ?? []),
            ];
            setJobs(newjobs);
            kanbanObj?.refresh();
          } else {
            // const prevJob = [...jobs];
            // console.log(`Previous jobs: ${JSON.stringify(prevJob)}`);

            // const newjobs = [
            //   ...addOrUpdateJob(jobActionMessage.job, prevJob ?? []),
            // ];

            // console.log(`Updated jobs: ${JSON.stringify(newjobs)}`);
            // setJobs(newjobs);
            console.log(`Reloading jobs due to job action: ${jobActionMessage.jobAction}`);
            loadJobs(warehouse);
            kanbanObj?.refresh();
          }
        }
      });
    }

    return () => {
      if (signalRService.connection) {
        console.log(`stopping connection`);
        signalRService.connection.stop();
      }
    };
  }, [userToken]);

  useEffect(() => {
    // if (!jobs || jobs.length === 0) {
    //   loadJobs(warehouse);
    // }

    loadJobs(warehouse);

    getStartedJobByUser(auth)
      .then((job) => {
        setStartedJob(job);
      })
      .catch((error) => {
        const message = `Failed to get started job. Error: ${error}`;
        console.error(`Failed to get started job. Error: ${error}`);
        ToastUtility.show(message, "Error", 2000);
      });
  }, [warehouse]);

  useEffect(() => {
    getBankHolidays(auth)
      .then((holidays) => {
        setBankHolidays(holidays);
      })
      .catch((error) => {
        const message = `Failed to get bank holidays. Error: ${error}`;
        console.error(message);
        ToastUtility.show(message, "Error", 2000);
      });
    getOperations(auth)
      .then((val) => {
        setOperations(val);
      })
      .catch((error) => {
        const message = `Failed to get operations. Error: ${error}`;
        console.error(`Failed to get operations. Error: ${error}`);
        ToastUtility.show(message, "Error", 2000);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getOperations(auth, operationFilter?.name)
      .then((val) => {
        setOperations(val);
      })
      .catch((error) => {
        const message = `Failed to get operations. Error: ${error}`;
        console.error(`Failed to get operations. Error: ${error}`);
        ToastUtility.show(message, "Error", 2000);
      });
  }, [operationFilter]);

  useEffect(() => {
    if (kanbanObj) {
      let value = searchValue;
      let searchQuery = new Query();
      if (showOnlyOnHoldJobs) {
        searchQuery = new Query().where('onHold', 'equal', true);
      }
      else if (value && value !== "") {
        searchQuery = new Query().search(
          value,
          ["jobNumber", "stockCode"],
          "contains",
          true,
        );
      }
      kanbanObj.query = searchQuery;
      if (operations) {
        let columns = [];
        let group = Object.groupBy(
          operations,
          ({ resourceAlias }) => resourceAlias,
        );
        for (var g in group) {
          columns.push({
            headerText: group[g]?.[0].resourceNo,
            keyField: group[g]
              ?.map((o) => {
                return o.resourceNo;
              })
              ?.join(", "),
            allowToggle: true,
            template: columnTemplate,
          });
        }

        const areArraysEqual =
          columns.length === kanbanObj.columns.length &&
          columns.every(
            (value, index) =>
              value.headerText === kanbanObj?.columns[index]?.headerText,
          );

        if (!areArraysEqual) {
          if (columns.length > 0) {
            kanbanObj.width = columns.length * 260;
            kanbanObj.columns = columns;
          }
        }
      }
    }
  }, [searchValue, operations, bankHolidays, jobs, showOnlyOnHoldJobs]);

  return (
    <>
      <JobAction key="kanbanAction" ref={refJobAction} />
      {jobs && jobs.length > 0 ? (
        <KanbanComponent
          id="kanban"
          width={2500}
          enableVirtualization
          cardHeight="200"
          ref={(kanban: KanbanComponent) => {
            kanbanObj = kanban;
          }}
          keyField="operation"
          dataSource={jobs}
          cardSettings={{
            template: cardTemplate.bind(this),
            headerField: "jobNumber",
            showHeader: true,
          }}
          allowDragAndDrop={false}
          cardDoubleClick={CardDoubleClick}
          dialogOpen={DialogOpen.bind(this)}
        >
          <ColumnsDirective>
            <ColumnDirective headerText="CHECK BOM" keyField="CHECK BOM" />
            <ColumnDirective headerText="PREP JOB" keyField="PREP JOB" />
            <ColumnDirective headerText="ASSEMBLY" keyField="ASSEMBLY" />
            <ColumnDirective headerText="WELD" keyField="WELD" />
            <ColumnDirective headerText="QUAR" keyField="QUAR" />
          </ColumnsDirective>
        </KanbanComponent>
      ) : (
        <>Loading...</>
      )}
    </>
  );
};
